module.exports = __webpack_public_path__ + "images/sgp/MediumStorage/MediumSizeSelfStorageUseCases.webp";